import React from 'react'
import styled from 'styled-components/macro'
import Header from '../../organisms/Header'
import Footer from '../../organisms/Footer'
import backgroundImg from '../../../assets/img/background_img.png'

type Props = {
  children: React.ReactNode
  backgroundImg?: boolean
}
function Presenter({ children, backgroundImg = false }: Props) {
  return (
    <>
      <Header />
      {backgroundImg ? <BackgroundImg /> : null}
      <MainWrap>{children}</MainWrap>
      <Footer />
    </>
  )
}

export { Presenter }
export type { Props }

const BackgroundImg = styled.div`
  width: 100%;

  &:before {
    z-index: -1;
    content: '';
    background-image: url(${backgroundImg});
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.8;
  }
  background-size: contain;
  background-repeat: no-repeat;
`
const MainWrap = styled.div`
  width: 100%;
  max-width: 59rem;
  margin: 0 auto;
  @media ${(props) => props.theme.media['2xl']} {
    max-width: 59rem;
    padding: 0 5rem;
  }

  @media ${(props) => props.theme.media.md} {
    padding: 0 1rem;
  }
`
